// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Text may contain HTML tags limited to the following:\n\n- `<b>`, `<i>`, `<em>`, `<strong>`, `<p>`, `<br>`, `<ul>`, `<li>`.\n\nAny other tags or attributes will be removed during validation.\n"
export default markdown
